<template>
  <div class="lad-itinerary-section">
    <LadItinerarySectionDays :days="visibleDays" :limit="limit" />

    <LadItinerarySectionPaginate
      v-if="daysNumber"
      :days-number="daysNumber"
      @change="handleChange"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { hydrateWhenVisible } from 'vue-lazy-hydration'
import GenericEventMixin from '@/utils/mixin/generic-event'

export default {
  name: 'LadItinerarySection',
  components: {
    LadItinerarySectionDays: () =>
      import(
        /* webpackChunkName: "lad-itinerary-section-days" */ './components/days'
      ),
    LadItinerarySectionPaginate: hydrateWhenVisible(() =>
      import(
        /* webpackChunkName: "lad-itinerary-section-paginate" */ './components/paginate'
      )
    ),
  },
  mixins: [GenericEventMixin],
  data() {
    return {
      limit: this.$route.params.test === 'ppcv1' ? 1 : 3,
    }
  },
  computed: {
    ...mapState('settings', ['currency']),
    ...mapState('experience', {
      exItinerary: (state) => state.itinerary,
      exExperience: (state) => state.experience,
      totalAmount: (state) => state.sales_plan.total_amount,
    }),
    visibleDays() {
      return this.exItinerary
    },
    daysNumber() {
      return this.exItinerary.length - this.limit
    },
  },
  methods: {
    async handleChange() {
      this.limit = this.exItinerary.length

      this.$store.dispatch('app/setPromptInstall', {
        showPromptInstall: true,
        source: 'show_more_days',
      })

      const data = {
        name: 'show_itinerary',
        currency: this.currency,
        experience: { ...this.exExperience, total_amount: this.totalAmount },
      }

      await this.sendGenericEvent(data)
    },
  },
}
</script>
